export const RINGBA_TAG_VALUES = [
  { text: "true", value: true },
  { text: "false", value: false },
  { text: "53", value: 53 },
  { text: "65", value: 65 },
  { text: "86", value: 86 },
];

export const TEMPLATE_PRESETS = {
  dark: {
    formBackgroundColor: "#000000B3",
    formBorderColor: "#3c00ffFF",
    formTextColor: "#FFFFFFFF",
    actionBackgroundColor: "transparent",
    actionTextColor: "#FFFFFFFF",
    actionBorderColor: "#FF0000FF",
    actionPadding: "14px 0",
    progressBarColor: "#FF0000FF",
    checkingElementTextColor: "#FFFFFFFF",
    checkingElementIconColor: "#FF0000FF",
    inputButtonTextColor: "#FFFFFFFF",
    inputButtonBackgroundColor: "transparent",
    inputButtonBorderColor: "#FF0000FF",
  },
  white: {
    formBackgroundColor: "transparent",
    formBorderColor: "#808080FF",
    formTextColor: "#000000FF",
    actionBackgroundColor: "#28a745FF",
    actionTextColor: "#FFFFFFFF",
    actionBorderColor: "#28a745FF",
    actionPadding: "",
    progressBarColor: "#28a745FF",
    checkingElementTextColor: "#000000FF",
    checkingElementIconColor: "#28a745FF",
    inputButtonTextColor: "#FFFFFFFF",
    inputButtonBackgroundColor: "#28a745FF",
    inputButtonBorderColor: "#28a745FF",
  },
};

export const CHECKING_ICON_OPTIONS = [
  { text: "None", value: "none" },
  { text: "✔ Checkmark", value: "✔" },
  { text: "✓ Light checkmark", value: "✓" },
  { text: "● Circle", value: "●" },
  { text: "★ Star", value: "★" },
  { text: "➜ Arrow", value: "➜" },
  { text: "◆ Diamond", value: "◆" },
  { text: "✦ Four-pointed star", value: "✦" },
  { text: "• Bullet", value: "•" },
];

export const BUTTON_LAYOUT_OPTIONS = [
  { text: "Vertical", value: "vertical" },
  { text: "Horizontal", value: "horizontal" },
];

export const PAGE = {
  pageType: "page",
  content: "",
  backgroundColor: "",
  delay: 0,
  cssClass: "",
  hasRingbaScript: false,
  ringbaScript: "",
  children: [],
  isLastPage: false,
  image: { imageID: "", imageURL: "" },
  buttonLayout: "vertical",
  progressBar: {
    enabled: false,
    color: "#007bffFF",
    duration: 3000,
    textAbove: "",
    textBelow: "",
  },
  checkingElement: {
    enabled: false,
    items: [],
    textColor: "",
    autoAdvance: true,
    timeBetweenItems: 700,
    checkSize: 16,
    checkIcon: "✔",
  },
};

export const INPUT_QUESTION = {
  pageType: "inputQuestion",
  delay: 0,
  content: "",
  children: [],
  inputQuestionType: "",
  buttonText: "Confirm →",
  buttonColor: "",
  buttonTextColor: "",
  buttonBorderColor: "",
  displayUserAnswer: false,
};

export const ACTION = {
  pageType: "action",
  text: "",
  backgroundColor: "",
  textColor: "",
  borderColor: "",
  value: "",
  href: "",
  target: "",
  textBelow: "",
  padding: "",
  hasRingbaScript: false,
  ringbaScript: "",
  updateRingbaTags: false,
  ringbaTags: [],
  children: [],
};

export const ZIP_INPUT_QUESTION = {
  pageType: "zipInputQuestion",
  delay: 0,
  content: "",
  children: [],
  zipInputDisplayType: "",
  buttonText: "Confirm",
  buttonColor: "",
  buttonTextColor: "",
  buttonBorderColor: "",
  placeholderText: "e.g., 12345",
  overrideZipOnly: true,
  overrideZipAndLocation: false,
};

export const ZIP_INPUT_DISPLAY_TYPES = [
  { value: "empty", text: "Empty input" },
  { value: "prefilled", text: "Pre-filled input" },
];

export const ZIP_OVERRIDE_MODE = {
  ZIP_ONLY: "zipOnly",
  ZIP_AND_LOCATION: "zipAndLocation",
};

export const DECISION = {
  pageType: "decision",
  children: [],
  ringbaTags: [],
  greaterThan: null,
  greaterThanOrEqual: null,
  lessThan: null,
  lessThanOrEqual: null,
};
